<ul class="row list-community">
    <li *ngFor="let community of communities || [] | slice : 0 : 3">
        <span class="badge badge-primary mr-1">{{ community.displayName }}</span>
        <em
            *ngIf="community.isPrimary"
            class="icon icon-star favorite"
            data-toggle="tooltip"
            data-placement="top"
            [title]="'Communauté principale'"
        ></em>
        <ng-container *ngFor="let role of community?.roles || []">
            <em
                class="icon"
                [ngClass]="{
                    'icon-role-manager': role.code === 'CommunityManager',
                    'icon-role-wizard': role.code === 'CommunityAnimator'
                }"
                data-toggle="tooltip"
                data-placement="top"
                [title]="role.libelle"
            ></em>
        </ng-container>
    </li>
    <button
        pButton
        pRipple
        *ngIf="communities.length > 1"
        type="button"
        (click)="showCommunitiesDialog()"
        label="{{ 'profile.pages.edit.editPrimaryCommunity' | translate }}"
        class="p-py-0 p-mt-1 p-button-sm"
    ></button>
</ul>

<p-dialog
    header="{{ 'profile.pages.edit.selectPrimaryCommunity' | translate }}"
    [(visible)]="communitiesDialog"
    [modal]="true"
    appendTo="body"
    [style]="{ width: '40rem' }"
>
    <div class="row">
        <div *ngFor="let community of communities || []" class="col-4 mb-3">
            <div
                class="community-item-card"
                (click)="selectCommunity(community.id)"
                [ngClass]="{
                    'primary-community': community.isPrimary,
                    'selected-community': community.id === selectedCommunityId
                }"
            >
                <div class="community-name">{{ community.displayName }}</div>
                <em class="icon icon-star selection-indicator-star favorite"></em>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button
            type="button"
            class="btn btn-primary"
            *ngIf="selectedCommunityId && selectedCommunityId !== initialPrimaryCommunityId"
            (click)="confirmNewPrimaryCommunity()"
        >
            {{ 'profile.pages.edit.defineAsPrimaryCommunity' | translate }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="communitiesDialog = false">
            {{ 'components.button.buttonClose' | translate }}
        </button>
    </ng-template>
</p-dialog>
